import React from "react";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AllTeamsList from '../../components/admincomponents/AllTeamsList';

function TeamsList({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AllTeamsList  />            
    </>
  );
}

export default TeamsList;
